import { CbhIcon, CollapsibleBlock, Text } from "@clipboard-health/ui-components";
import { isDefined, isNil } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";

import { ButtonInternalLink } from "../../../components/ButtonInternalLink";
import { type Consequence, ConsequencePill, type ConsequenceType } from "./ConsequencePill";
import { getIcon } from "./icon";
import { type Multiplier, MultiplierPill } from "./MultiplierPill";

interface ActivityItemProps {
  label: string;
  consequence: Consequence | undefined;
  consequenceType: ConsequenceType;
  caption?: string | React.ReactNode;
  expanded?: boolean;
  setExpanded?: () => void;
  multiplier?: Multiplier;
  children?: React.ReactNode;
}

export function ActivityItem(props: ActivityItemProps) {
  const {
    label,
    consequence,
    consequenceType,
    multiplier,
    caption,
    expanded,
    setExpanded,
    children,
  } = props;

  const title = (
    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={5}>
      <Stack direction="row" spacing={2} alignItems="center">
        {isDefined(consequence) && <CbhIcon type={getIcon(consequence)} size="xSmall" />}
        <Text
          bold
          sx={{
            paddingLeft: () => (isNil(consequence) ? 6 : 0),
            paddingY: () => (isNil(consequence) ? 2 : 0),
          }}
        >
          {label}
        </Text>
      </Stack>
      <Stack direction="row" spacing={2} alignItems="center">
        {isDefined(multiplier) &&
          isDefined(consequence) &&
          typeof consequence === "number" &&
          consequence !== 0 && <MultiplierPill multiplier={multiplier} />}
        {isDefined(consequence) && (
          <ConsequencePill consequence={consequence} type={consequenceType} />
        )}
      </Stack>
    </Stack>
  );

  return (
    <Stack direction="column">
      {isDefined(children) && isDefined(expanded) && isDefined(setExpanded) ? (
        <CollapsibleBlock
          title={title}
          expanded={expanded}
          LinkComponent={ButtonInternalLink}
          onChange={setExpanded}
        >
          {children}
        </CollapsibleBlock>
      ) : (
        title
      )}
      {isDefined(caption) && (
        <Text variant="body2" sx={{ paddingLeft: 6 }}>
          {caption}
        </Text>
      )}
    </Stack>
  );
}
